/* This example requires Tailwind CSS v2.0+ */
import { ChatAltIcon } from '@heroicons/react/outline';
import {
  AuthenticatorIcon,
  RecoveryCodeIcon,
  SecurityKeyIcon
} from '../../common/icons';
import SaneImage from '@components/sanity/sane-image';
import { PageProps } from '../../../types/page-props';

const heading = 'Flexible MFA options';

const subheading = `
Empower your users with security how you see fit.  With 
Or, enable every option and let your users decide.
`;

const features = [
  {
    id: 1,
    name: 'SMS Passcodes',
    description: (
      <>
        The most common way to implement MFA. While{' '}
        <a
          href="https://owasp.org/www-community/attacks/Brute_force_attack"
          target="_blank"
          rel="nofollow noreferrer"
        >
          less secure than other options
        </a>
        , it provides the most familiar UI and UX to your users.
      </>
    ),
    icon: ChatAltIcon
  },
  {
    id: 2,
    name: 'Authenticator Apps (TOTP)',
    description: (
      <>
        Enable MFA with Google authenticator, Authy, Duo, and other
        authenticator apps that follow the{' '}
        <a
          href="https://datatracker.ietf.org/doc/html/rfc6238"
          target="_blank"
          rel="nofollow noreferrer"
        >
          IETF standarized
        </a>{' '}
        TOTP protocol.
      </>
    ),
    icon: AuthenticatorIcon
  },
  {
    id: 2,
    name: 'Hardware Keys',
    description: (
      <>
        FIDO2 hardware keys, such as YubiKeys, are a strong hardware based
        multifactor option.{' '}
      </>
    ),
    icon: SecurityKeyIcon
  },
  {
    id: 2,
    name: 'Recovery Codes',
    description: (
      <>
        Recovery codes are often used as a "backup" to MFA, when all else fails,
        your users can use these recovery codes to gain access to their account.
      </>
    ),
    icon: RecoveryCodeIcon
  }
];

export function FlexibleOptions({ image }: PageProps) {
  return (
    <div className="overflow-hidden py-16 lg:py-24">
      <div className="relative mx-auto max-w-xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="relative lg:grid lg:grid-cols-2 lg:gap-8">
          <div className="relative">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              {heading}
            </h2>
            <p className="mt-3 text-lg text-gray-500">{subheading}</p>

            <div className="mt-10 space-y-10">
              {features.map(item => (
                <div key={item.id} className="relative">
                  <div>
                    <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-clerk-blue text-white">
                      <item.icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    <h3 className="ml-16 text-xl font-medium leading-6 text-gray-900">
                      {item.name}
                    </h3>
                  </div>
                  <div className="mt-2 ml-16 text-lg text-gray-500">
                    {item.description}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div
            className="relative -mx-4 mt-10 px-16 lg:mt-0"
            aria-hidden="true"
          >
            <SaneImage
              className="relative mx-auto"
              src={image.passwordgraphic}
              alt="Password security illustration"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
